import styled from 'styled-components';


const Icons = styled.small`

&.icon-container2 {
	text-align: left;
	background: ${({ theme }) => theme.colorBorderBtn};
	padding: 7px 2px 7px 7px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	margin-left: 0;
	margin-right: 10px;
	svg {
		margin-left: auto;
		margin-right: 5px;
	}
}

`

export default Icons;


